import { render, staticRenderFns } from "./quotaWithdrawModal.vue?vue&type=template&id=3ff4b222&scoped=true"
import script from "./quotaWithdrawModal.vue?vue&type=script&lang=js"
export * from "./quotaWithdrawModal.vue?vue&type=script&lang=js"
import style0 from "./quotaWithdrawModal.vue?vue&type=style&index=0&id=3ff4b222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff4b222",
  null
  
)

export default component.exports